import React, { useState } from 'react';
import { Table } from 'semantic-ui-react';
import { useData } from '../context/DataContext';

const RESULTS_PER_PAGE = 25;

const parseRank = (val) => {
  const n = parseInt(val, 10);
  return isNaN(n) ? Infinity : n;
};

const LeaderboardPage = () => {
  const { data, isLoading, error } = useData();
  const [page, setPage] = useState(1);

  if (isLoading) {
    return <div className="container mt-5 text-center premium-loading">Chargement des données...</div>;
  }

  if (error) {
    return <div className="container mt-5 text-center premium-error">{error}</div>;
  }

  const sorted = [...data].sort((a, b) => parseRank(a['Cl. Gal']) - parseRank(b['Cl. Gal']));
  const totalPages = Math.ceil(sorted.length / RESULTS_PER_PAGE) || 1;
  const pageItems = sorted.slice((page - 1) * RESULTS_PER_PAGE, page * RESULTS_PER_PAGE);

  return (
    <div className="container mt-5">
      <h3 className="text-center mb-4 premium-section-title">Classement général — Top patineurs</h3>

      {sorted.length === 0 ? (
        <p className="text-center text-muted">Aucune donnée disponible pour cette saison/genre.</p>
      ) : (
        <>
          <Table celled compact className="premium-table">
            <Table.Header>
              <Table.Row className="text-center">
                <Table.HeaderCell>Rang</Table.HeaderCell>
                <Table.HeaderCell>Nom Prénom</Table.HeaderCell>
                <Table.HeaderCell>Club</Table.HeaderCell>
                <Table.HeaderCell>Catégorie</Table.HeaderCell>
                <Table.HeaderCell>Médaille</Table.HeaderCell>
                <Table.HeaderCell>Meilleur Score</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {pageItems.map((m, i) => (
                <Table.Row key={i} className="text-center">
                  <Table.Cell><strong>{m['Cl. Gal']}</strong></Table.Cell>
                  <Table.Cell>{m['Nom']} {m['Prénom']}</Table.Cell>
                  <Table.Cell>{m['Club']}</Table.Cell>
                  <Table.Cell>{m['Catégorie']}</Table.Cell>
                  <Table.Cell>{m['Méd.']}</Table.Cell>
                  <Table.Cell>{m['Season Best'] || m['Score Best'] || '—'}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>

          {totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-4 mb-5">
              <span className="text-muted">Page {page} sur {totalPages}</span>
              <div className="btn-group">
                <button className="btn btn-outline-secondary" disabled={page === 1} onClick={() => setPage(p => p - 1)}>
                  Précédent
                </button>
                <button className="btn btn-outline-secondary" disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>
                  Suivant
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LeaderboardPage;
